import './ShareBox.scss';